import { Controller } from '@hotwired/stimulus';

// URL のハッシュが指す collapse を開く。Bootstrap の collapse は閉じた状態で
// 描画されるため、外部からのリンクで来ても本文が見えない。
export default class extends Controller {
  connect() {
    this.openFromHash();
    this.hashChangeHandler = this.openFromHash.bind(this);
    window.addEventListener('hashchange', this.hashChangeHandler);
  }

  disconnect() {
    window.removeEventListener('hashchange', this.hashChangeHandler);
  }

  openFromHash() {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    let target;
    try {
      target = this.element.querySelector(hash);
    } catch (e) {
      return;
    }
    if (!target) return;

    const panel = target.classList.contains('collapse') ? target : target.querySelector('.collapse');
    if (!panel || panel.classList.contains('show')) return;

    panel.classList.add('show');

    const toggle = this.element.querySelector(`[data-bs-target="#${panel.id}"]`);
    if (toggle) {
      toggle.classList.remove('collapsed');
      toggle.setAttribute('aria-expanded', 'true');
    }

    target.scrollIntoView();
  }
}
